var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4406_77142)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#272A3A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4931 15.5069L13.1213 16.8787C11.9497 18.0503 11.9497 19.9497 13.1213 21.1213C14.2929 22.2929 16.1924 22.2929 17.364 21.1213L19.1924 19.2929C20.364 18.1213 20.364 16.2218 19.1924 15.0503C18.9445 14.8023 18.6639 14.6068 18.3646 14.4639L17.7782 15.0503C17.7172 15.1112 17.6657 15.1781 17.6238 15.2491C17.9392 15.3395 18.2368 15.5089 18.4853 15.7574C19.2663 16.5384 19.2663 17.8047 18.4853 18.5858L16.6569 20.4142C15.8758 21.1953 14.6095 21.1953 13.8284 20.4142C13.0474 19.6332 13.0474 18.3668 13.8284 17.5858L14.621 16.7932C14.5088 16.3731 14.4662 15.9382 14.4931 15.5069Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.364 13.636C15.1924 14.8076 15.1924 16.7071 16.364 17.8787C16.6119 18.1266 16.8924 18.3221 17.1918 18.4651L17.9674 17.6895C17.639 17.6018 17.3287 17.4292 17.0711 17.1716C16.29 16.3905 16.29 15.1242 17.0711 14.3431L18.8995 12.5147C19.6805 11.7337 20.9469 11.7337 21.7279 12.5147C22.509 13.2958 22.509 14.5621 21.7279 15.3431L20.9353 16.1358C21.0475 16.5559 21.0902 16.9907 21.0633 17.422L22.435 16.0503C23.6066 14.8787 23.6066 12.9792 22.435 11.8076C21.2635 10.636 19.364 10.636 18.1924 11.8076L16.364 13.636Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4406_77142",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4406_77142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4406_77142",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLink);
export default __webpack_public_path__ + "static/media/BlackLink.2c790706ab45f35cc9b7ec89d0572ce5.svg";
export { ForwardRef as ReactComponent };